"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _callee;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _stopSpeakingActivity = require("../actions/stopSpeakingActivity");

var _markActivity = _interopRequireDefault(require("../actions/markActivity"));

var _speakingActivity = _interopRequireDefault(require("../definitions/speakingActivity"));

var _activities = require("../selectors/activities");

var _marked =
/*#__PURE__*/
_regenerator["default"].mark(_callee),
    _marked2 =
/*#__PURE__*/
_regenerator["default"].mark(markAllAsSpoken);

function _callee() {
  return _regenerator["default"].wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.takeEvery)(_stopSpeakingActivity.STOP_SPEAKING_ACTIVITY, markAllAsSpoken);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function markAllAsSpoken() {
  var speakingActivities, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, activity;

  return _regenerator["default"].wrap(function markAllAsSpoken$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.select)((0, _activities.of)(_speakingActivity["default"]));

        case 2:
          speakingActivities = _context2.sent;
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context2.prev = 6;
          _iterator = speakingActivities[Symbol.iterator]();

        case 8:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context2.next = 15;
            break;
          }

          activity = _step.value;
          _context2.next = 12;
          return (0, _effects.put)((0, _markActivity["default"])(activity, 'speak', false));

        case 12:
          _iteratorNormalCompletion = true;
          _context2.next = 8;
          break;

        case 15:
          _context2.next = 21;
          break;

        case 17:
          _context2.prev = 17;
          _context2.t0 = _context2["catch"](6);
          _didIteratorError = true;
          _iteratorError = _context2.t0;

        case 21:
          _context2.prev = 21;
          _context2.prev = 22;

          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }

        case 24:
          _context2.prev = 24;

          if (!_didIteratorError) {
            _context2.next = 27;
            break;
          }

          throw _iteratorError;

        case 27:
          return _context2.finish(24);

        case 28:
          return _context2.finish(21);

        case 29:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[6, 17, 21, 29], [22,, 24, 28]]);
}